export default (props, vars) => () =>
  vars?.['usestateprofilepopupopened']?.['setState'](undefined);
